import React, { useState } from 'react';

import { DefaultFieldComponentProps } from 'components/Field';
import Image from 'components/Image';

import { StyledInputSecret, Icon } from './styles';

export interface Props extends DefaultFieldComponentProps<HTMLInputElement> {
  onChange?: (input: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  id?: string;
  mask?: string;
  maskChar?: string;
  placeholder?: string;
}

const InputSecret = (props: Props) => {
  const [hidden, setHidden] = useState(true);

  return (
    <StyledInputSecret mask={props.mask || ''} type={`${hidden ? 'password' : 'text'}`} {...props}>
      <Icon onClick={() => setHidden(!hidden)}>
        <Image src={hidden ? '/images/password-active.svg' : '/images/password-disabled.svg'} />
      </Icon>
    </StyledInputSecret>
  );
};

export default InputSecret;
